function initQuickAddButtons() {

    var cardQuickAddBtns = document.querySelectorAll( ".product-grid .grid__item:not(.js-loaded) .card__quick-add__hover--btn:not(.card__quick-add__hover--btn-sold-out)" );
  
    if( cardQuickAddBtns && cardQuickAddBtns.length )
    {
        cardQuickAddBtns.forEach( function( btn )
        {
            btn.addEventListener( "click", function( e )
            {

                            var parent = e.currentTarget.closest( ".card-wrapper" );
                var quickAddContainer = parent.querySelector( ".card__quick-add__hover-container" );
                if( quickAddContainer )
                    {
                        if( quickAddContainer.classList.contains( "active" ) )
                        {
                            quickAddContainer.classList.remove( "active" ); 
                            HandleQuickAddToggleText( btn, "close" );
                        }
                        else
                        {
                            quickAddContainer.classList.add( "active" );
                            HandleQuickAddToggleText( btn, "show" );
                        }
                    }
            });
        });
    }
    
    function HandleQuickAddToggleText( btn, type )
    {
        var openText    = btn.getAttribute( "data-open-text" );
        var closeText   = btn.getAttribute( "data-close-text" );
    
        if( openText && closeText )
        {
            if( type == "show" )
            {
                btn.innerText = closeText;
            }
            else if( type == "close" )
            {
                btn.innerText = openText;
            }
        }
    }
    
    var cardWrappers = document.querySelectorAll( ".product-grid .grid__item:not(.js-loaded) .card-wrapper" );
    cardWrappers.forEach( function( card )
    {
        card.addEventListener( "mouseleave", function( e )
        {
            var quickAddContainer = e.currentTarget.querySelector( ".card__quick-add__hover-container" );
            var btn               = e.currentTarget.querySelector( ".card__quick-add__hover--btn" );
            if( quickAddContainer && quickAddContainer.classList.contains( "active" ) )
            {
                quickAddContainer.classList.remove( "active" );
                HandleQuickAddToggleText( btn, "close" );
            }
        });
    });
    
    var cardOptionInputs = document.querySelectorAll( ".product-grid .grid__item:not(.js-loaded) .card__quick-add__option-container input" );
    cardOptionInputs.forEach( function( input )
    {
        input.addEventListener( "change", function( e )
        {
            var parent = input.closest( ".card__quick-add__hover-container" );
            var productInputs = parent.querySelectorAll( "input" );
            var productATC = parent.querySelector( ".card__quick-add__atc" );
            productATC.classList.remove( "disabled" );
            for( var i = 0; i < productInputs.length; i++ )
            {
                if( productInputs[ i ] != input && productInputs[ i ].checked )
                {
                    productInputs[ i ].checked = false;
                    input.classList.remove( "selected-input" );
                }
            }
            input.classList.add( "selected-input" );
        });
    });
    
    var cardATCbtns = document.querySelectorAll( ".product-grid .grid__item:not(.js-loaded) .card__quick-add__atc" );
    cardATCbtns.forEach( function( btn )
    {
        btn.addEventListener( "click", function( e )
        {
            if( btn.classList.contains( "disabled" ) == false )
            {
                var parent = btn.closest( ".card__quick-add__hover-container" );
                var selectedInput = parent.querySelector( "input.selected-input" );
                btn.classList.add( "loading" );
                btn.querySelector('.loading__spinner').classList.remove('hidden');
        
                var variantID = selectedInput.getAttribute( 'data-variant-id' );
                var quantity = 1; // or any other dynamically set quantity
        
                fetch( '/cart/add.js', 
                {
                    method: 'POST',
                    headers: 
                    {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify( { id: variantID, quantity: quantity } ),
                })
                .then( function ( response )
                {
                    
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'quick-add-form-form',
                        productVariantId: variantID,
                        cartData: response,
                    });

                    return response.json();
                })
                .then( function ( data ) 
                {
                    if ( data.status === 'bad_request' ) 
                    {
                        console.error( 'Error adding product to cart:', data );
                    } else 
                    {




                        btn.classList.remove( "loading" );
                        btn.querySelector('.loading__spinner').classList.add('hidden');
                        var cart = document.querySelector( "cart-drawer" );
                        fetch("/cart.js")
                        .then((response) => {
                            return response.json()
                        })
                        .then((response) => {
                            if( response )
                            {
                                var items = response.items;
                                items.forEach( function( item )
                                {
                                    if( item.variant_id == variantID )
                                    {
                                        fetch(window.Shopify.routes.root + "?sections=cart-drawer,cart-icon-bubble")
                                        .then( function( response )
                                        {
                                            return response.json();
                                        })
                                        .then( function( data )
                                        {
                                            item.sections = data;
                                            cart.renderContents( item );
                                        })
                                    }
                                });
                            }
                        });
                    }
                })
                .catch( function ( error ) 
                {
                    console.error( 'Error adding product to cart:', error );
                });
            }
        });
    });
    
    var gridItems = document.querySelectorAll( ".product-grid .grid__item:not(.js-loaded)" );
    gridItems.forEach( function( item )
    {
        item.classList.add("js-loaded");
    });

}

initQuickAddButtons();